import { SubmitHandler, useFormContext, UseFormReturn } from "react-hook-form";

import { alertActions } from "../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { updateSettings } from "../../../../lib/api";
import { ISiteSettingsForm } from "../../../../types/forms";
import { globalActions } from "../../../../features/global/globalSlice";

const useFormSubmitHandler = (methods: UseFormReturn<ISiteSettingsForm>) => {
    const dispatch = useAppDispatch();

    const onSubmit: SubmitHandler<Partial<ISiteSettingsForm>> = async data => {
        const dirtyFields = methods.formState.dirtyFields;

        const filteredData: Partial<ISiteSettingsForm> = {
            date: {},
            content: {},
        };

        (Object.keys(dirtyFields) as Array<keyof ISiteSettingsForm>).forEach(
            category => {
                const dirtySubfields = dirtyFields[category];
                Object.keys(dirtySubfields).forEach(subfield => {
                    if (data[category]?.hasOwnProperty(subfield)) {
                        filteredData[category][subfield] =
                            data[category][subfield];
                    }
                });
            },
        );

        (Object.keys(filteredData) as Array<keyof ISiteSettingsForm>).forEach(
            category => {
                if (Object.keys(filteredData[category]).length === 0) {
                    delete filteredData[category];
                }
            },
        );

        const promises: Array<Promise<any>> = [
            dispatch(globalActions.updateNotice(data.siteNotice)),
            updateSettings(filteredData),
        ];

        await Promise.all(promises)
            .then(() => {
                dispatch(
                    alertActions.success({
                        title: "Settings updated successfully",
                        dismissible: true,
                    }),
                );
            })
            .catch(e =>
                dispatch(
                    alertActions.error({
                        title: "The server encountered a problem updating the settings.",
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                ),
            );
    };

    return { onSubmit };
};

export default useFormSubmitHandler;
